import { priceLabelToNumber } from 'shared/util/price'

export const parsePersonalisationData = (favouritesItemIds, response = {}) => {
  const {
    modules: [
      {
        metadata: { placement = '' },
        module_data: [{
          list_data: items = [],
          // eslint-disable-next-line camelcase
          list_metadata: { strategy_id = '', strategy_message = '' },
        }] = [{}],
      },
    ] = [{}],
  } = response
  const isUnavailable = availability => (availability ? ['O', 'I', 'C'].includes(availability) : true)
  const shouldHidePrice = (salePrice, pricePerUnit, onSale) => {
    const salePriceNum = priceLabelToNumber(salePrice)
    const priceNum = priceLabelToNumber(pricePerUnit)
    return (!!pricePerUnit && priceNum < 0.01) || (onSale && salePriceNum < 0.01)
  }
  const processedItems = items.map((itemObj) => {
    const {
      item_id: itemId,
      is_bundle: isBundle,
      item = {},
      price: itemPrice = {},
      inventory = {},
      promotion_info: promotionInfo = [{}],
    } = itemObj.list_item
    const {
      cin,
      name,
      brand,
      bundle_item_count: bundleItemCount,
      bundle_item_quantity: bundleItemQuantity,
      taxonomy_info: {
        aisle_id: aisleId,
        dept_id: deptId,
        aisleName,
        dept_name: deptName,
        primary_shelf: primaryShelf,
        shelf_name: shelfName,
        shelf_id: shelfId,
        category_id: categoryId,
        category_name: categoryName,
        category_type: categoryType,
      } = {},
      rating_review: { total_review_count: totalReviewCount, avg_star_rating: avgStarRating } = {},
      images: { scene7_host: scene7Host, scene7_id: scene7Id } = {},
      icons = [],
      extended_item_info: { weight } = {},
    } = item
    const {
      bundle_discount: bundleDiscount,
      bundled_items: bundledItems,
      price_info: {
        price,
        price_per_uom: pricePerUom,
        sales_unit: salesUnit,
        avg_weight: avgWeight,
        sale_price: salePrice,
      } = {},
      is_on_sale: isOnSale,
    } = itemPrice
    const { availability_info: { max_quantity: maxQuantity, availability } = {} } = inventory
    const {
      base_promotion: { item_promo_type: itemPromoType } = {},
      rollback: { was_price: wasPrice } = {},
      linksave: {
        meat_sticker_details: meatStickerDetails,
        promo_detail: promoDetail,
        promo_id: promoId,
        promo_offer_type: promoOfferType,
        promo_quantity: promoQuantity,
        promo_value: promoValue,
      } = {},
    } = promotionInfo[0]
    const isLinkSave = promoDetail !== '' && (promoOfferType > 0 || promoOfferType < 16)
    const allMeatStickerTypes = [6, 8, 13, 15]
    const isMeatSticker = allMeatStickerTypes.includes(parseInt(promoOfferType, 10))
    return {
      id: itemId,
      cin,
      productDetails: {
        id: itemId,
        name,
        description: '',
        brand,
        isFavourite: favouritesItemIds.includes(itemId),
      },
      ratingAndReview: {
        avgStarRating,
        totalReviewCount,
      },
      images: {
        scene7Id,
        scene7Host,
      },
      priceDetails: {
        pricePerUnit: price,
        pricePerUOM: pricePerUom,
        wasPrice,
        unit: salesUnit,
        salePrice,
        isUnavailable: isUnavailable(availability),
        shouldHidePrice: shouldHidePrice(salePrice, price, isOnSale),
        availability,
      },
      promoDetails: {
        bundledItemCount: bundleItemCount,
        bundledItemQuantity: bundleItemQuantity,
        bundleItems: bundledItems,
        isBundle,
        bundleDiscount,
        meatStickerDetails,
        promoDetail,
        promoId,
        promoOfferTypeCode: promoOfferType,
        promoQty: promoQuantity,
        promoValue,
        type: itemPromoType,
        onSale: isOnSale,
        isLinkSave,
        isMeatSticker,
      },
      quantityDetails: {
        type: salesUnit,
        weight,
        averageWeight: avgWeight,
        maxQty: maxQuantity,
      },
      taxonomyDetails: {
        aisleId,
        aisleName,
        catId: categoryId,
        catName: categoryName,
        catType: categoryType,
        deptId,
        deptName,
        primaryShelfName: primaryShelf,
        shelfId,
        shelfName,
      },
      iconDetails: {
        infoIcons: icons,
      },
    }
  })
  return {
    items: processedItems,
    metadata: {
      placement, strategyId: strategy_id, strategyMessage: strategy_message,
    },
  }
}



// WEBPACK FOOTER //
// ./services/app-state/personalizedRecommendation/actions/personalisationParser.js